<template>
    <div class="ex-shop">
        <div class="open-time"></div>
        <div class="shop-panel">
            <div class="shop-index-cap"></div>
            <div class="user-info">
                <m-user></m-user>
            </div>
            <div class="shop-view">
                <div class="skin-c-reward">
                    <p>根据<b>解锁</b>以下<b>嘉年华金牌系列换装</b>可享受优惠：</p>

                    <div class="skin-list">
                        <div class="skin-item" v-for="(item,index) in skinlist" :key="index">
                            <div class="pic" 
                            @click="$item_tips({ item_id : item.id})">
                                <div class="item-pic">
                                    <game-item :id="item.id" :num="1" :locked="true"></game-item>
                                </div>
                            </div>
                            
                            <div class="skin-name">{{ item.name }}</div>

                            <div class="status" :class="{'act' : skin_status[item.id.toLowerCase()] == 1}"></div>
                        </div>
                    </div>
                </div>

                <div class="slin-c-task">
                    <div class="task-item" v-for="(item,index) in ex_config" :key="index">
                        <div class="pic f-l" 
                            @click="$item_tips({ item_id : item.reward.id})">
                            <div class="item-pic">
                                <game-item :id="item.reward.id" :num="item.reward.num" :locked="true"></game-item>
                            </div>
                        </div>
                        
                        <div class="reward-detail">
                            <div class="item-name">{{ item.reward.name }} * {{ item.reward.num }}</div>
                            <div class="require">解锁{{ item.require }}个换装可领取（{{ unlock_num }}/{{ item.require }}）</div>
                        </div>

                        <div class="task-status">
                          <div class="u-btn apply act" v-if="taskinfo[(index + 1).toString()] == 0 && unlock_num >= item.require" @click="applyTask(index)">可领取</div>
                          <div class="u-btn disabled" v-if="taskinfo[(index + 1).toString()] == 0 && unlock_num < item.require">不可领取</div>
                          <div class="u-btn dismiss" v-if="taskinfo[(index + 1).toString()] == 1">已领取</div>

                        </div>

                    </div>
                </div>

                <div class="goods-list">
                    <vuescroll>
                        <ul>
                            <li v-for="(item,index) in goodslist" :key="index">
                                <div class="goods-panel">
                                    <div class="goods-detail">
                                        <div class="goods-status">
                                            <div class="tag tag-sale" v-if="item.discountType"></div>
                                            <div class="tag tag-shop" v-if="item.shopOfferType"></div>
                                        </div>
                                        <h6 class="item-name">{{ item.name }} * {{ item.itemcount }}</h6>
                                        <div class="discount">{{ item.discountName }}</div>
                                        <div class="pic" 
                                        v-if="$store.state.tipsimg.indexOf(item.itemid) > -1" 
                                        @click="$item_tips({ item_id : item.itemid + '.png',type : 'img'})">
                                        <!-- <img v-bind:src="item.img" v-bind:alt="item.name"> -->
                                        <div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div>
                                        </div>
                                        <div class="pic" v-else 
                                        @click="$item_tips({ item_id : item.itemid})"><div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div></div>
                                        <div class="low">最低价<em class="icon-m3b"></em><span>{{ item.priceMin }}</span><span class="p-before">{{ item.priceBefore }}</span></div>
                                        <div class="banner" v-bind:data-sid="item.shopId" @click="see_offer(item.shopId);">{{ item.shopName }}</div>
                                        <div class="require">解锁{{ item.target }}个换装可购买（{{ unlock_num }}/{{ item.target }}）</div>
                                    </div>
                                </div>

                                <div class="u-btn apply disabled" v-if="unlock_num < item.target"></div>
                                <div class="u-btn apply dismiss" v-if=" item.state == 1"></div>
                                <div class="u-btn apply" v-if="unlock_num >= item.target && item.state != 1" @click="discountStart(item.id,item);"></div>
                            </li>
                        </ul>
                    </vuescroll>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userinfo from '@/components/userinfo.vue'
import vuescroll from 'vuescroll';

export default {
  name: 'bazaar',
  data () {
    return {
      skinlist : [{id : 'FS72', name : '金牌龙王'},{id : 'FS76', name : '金牌大帝'},{id : 'FS68', name : '金牌飞鸿'},{id : 'FS70', name : '金牌军师'},{id : 'FS66', name : '金牌荣光'}],
      ex_config : [
        {
            reward : {id : 'MS70', name : '圆梦金镖（30天）', num : 600,},
            require : 1,
        },
        {
            reward : {id : 'MS70', name : '圆梦金镖（30天）', num : 900,},
            require : 2,            
        },
      ],
      goodslist : [],
      skin_status : {},
      taskinfo: {},
      unlock_num : 0,
      ops : {
        bar: {
            background: '#b28850',
            keepShow : true,
        }        
      }
    }
  },
  components : {
    'm-user': userinfo,
    vuescroll,
  },  
  created (){

    if(!parseInt(this.$store.state.login)){
      this.$router.push('/')
      return this.$mslogin.open();
    }
    if(!this.$store.state.userinfo){
      this.$router.push('/')
      return this.$toast('请先选择大区');
    }


    this.render();
    this.task_render();
  },
  methods : {
    render (){
        this.$axios.get(this.$ajax_url_map.w12_goodslist)
        .then(res => {
            this.goodslist = res.data.list;
            this.skin_status = res.data.targetList;

            for(var key in this.skin_status){
                if(this.skin_status[key] == 1){
                    this.unlock_num ++ ;
                }
            }
        },
        rej => {
            console.log(rej)
        }) 
    },
    discountStart (gid,item){
      //TODO
      this.$axios.post(this.$ajax_url_map.add_basket,this.$qs.stringify({
        id : gid,
      }))
      .then(
        res => {
            this.$toast('加入金算盘成功~');
            item.state = 1;
        },
        rej => {
            this.$toast(rej.message);
        }, 
      )
    },
    see_offer (sid){
      this.$router.push({ name: 'offer', params: { sid: sid }});
    },
    task_render (){
      this.$axios.get(this.$ajax_url_map.task)
      .then(res => {
        this.taskinfo = res.data.currentTargetDraw;
      },rej => {

      })
    },
    applyTask (index){
      var _this = this;
      this.$axios.post(this.$ajax_url_map.getfuli,this.$qs.stringify({
        type: 'currentTargetDraw',
        index: (index + 1).toString()       
      }))
      .then(res => {
        this.$toast('领取成功~')
        _this.taskinfo[(index + 1).toString()] = 1;
      },rej => {
        this.$toast(rej.message);
      })
    },
  },
}
</script>

<style scoped>
.ex-shop {
    position: relative;
    padding-top: 650px;
    background-image: url(~@/assets/images/body-ex.jpg);
    background-color: #341e0d;
    background-size: 750px auto;
    background-position: top center;
    background-repeat: no-repeat;
}

.shop-panel {
    position: relative;
    width: 750px;
    height: 2475px;
    padding-top: 20px;
    margin-bottom: 40px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/bg-ex-panel.png);
    box-sizing: border-box;
}

.m-user {
    position: absolute;
    left: 0;
    top: -10px;
    width: 100%;
    padding: 0 40px;
    color: #d4a869;
    box-sizing: border-box;
    z-index: 6;
}

.user-name{
    display: inline-block;
    width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;    
}

.skin-c-reward{
    padding-top: 70px;
    margin-bottom: 140px;
}

.skin-c-reward p{
    text-align: center;
    color: #dcc4b1;
}

.skin-c-reward p b{
    font-weight: 400;
    color: #ffcb7b;
}

.skin-list{
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding: 0 39px;
}

.skin-item{
    position: relative;
    width: 123px;
    height: 308px;
    padding-top: 22px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/skin-wrapper.png);
}

.skin-item .pic {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 99px;
    height: 99px;
    margin: 0 auto;
    transform: translateX(-1px);
    background-image: url(~@/assets/images/skin-item.png);
}

.skin-item .pic img {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}

.skin-name{
    margin-top: 24px;
    text-align: center;
    color: #683d1e;
}

.skin-item .status{
    position: absolute;
    left: 50%;
    bottom: 32px;
    transform: translateX(-50%);
    width: 72px;
    height: 74px;
    background-image: url(~@/assets/images/status-skin-disabled.png);
}

.skin-item .status.act{
    width: 73px;
    height: 89px;
    background-image: url(~@/assets/images/status-skin-act.png);    
}

.task-item{
    position: relative;
    width: 711px;
    height: 180px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/skin-fuli.png);  
}

.task-item .reward-detail{
    padding-top: 40px;
    padding-left: 180px;
}

.task-item .pic {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50px;
    top: 40px;
    width: 113px;
    height: 112px;
    background-image: url(~@/assets/images/bg-item_2.png);
}

.task-item .pic img {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}

.task-item .item-name{
    margin-bottom: 25px;
    font-size: 28px;
    font-weight: 700;
    color: #683d1e;
}

.task-item .require{
    font-size: 28px;
    color: #d33d27;
}

.task-item .task-status {
    position: absolute;
    top: 40px;
    right: 35px;
    color: transparent;
    font-size: 0;
}

.task-status .u-btn.dismiss {
    width: 101px;
    height: 111px;
    background-image: url(~@/assets/images/icon-status-get.png);
    filter: none;
}

.task-status .u-btn.disabled {
    width: 100px;
    height: 100px;
    background-image: url(~@/assets/images/btn-mission-apply-disabled.png);
    filter: none;
}

.task-status .u-btn {
    width: 100px;
    height: 100px;
    background-image: url(~@/assets/images/btn-mission-apply.png);
}

.shop-panel .goods-list ul{
    margin-top: 40px;
    padding: 0 22px;
}

.goods-list ul li{
    margin-bottom: 40px;
}

.shop-panel .goods-detail{
    position: relative;
    /* transform: translateX(5px); */
}

.shop-panel .goods-panel {
    position: relative;
    width: 352px;
    height: 479px;
    padding-top: 30px;
    background-image: url(~@/assets/images/bg-shop-fuli.png);
    box-sizing: border-box;
}

.goods-list .banner{
    margin: 15px auto 0;
}

.goods-detail .require{
    margin-top: 15px;
    text-align: center;
    color: #d33d27;
}

.shop-panel .goods-list .u-btn.apply {
    width: 256px;
    height: 96px;
    margin: 10px auto 0;
    background-image: url(~@/assets/images/btn-apply-fuli.png);
}

.goods-list .u-btn.apply.disabled{
    background-image: url(~@/assets/images/btn-apply-fuli-disabled.png);
}

.goods-list .u-btn.apply.dismiss{
    background-image: url(~@/assets/images/btn-apply-fuli-dismiss.png);
}

.open-time{
    position: absolute;
    right: 0;
    top: 0;
    width: 244px;
    height: 140px;
    background-image: url(~@/assets/images/act-time.png);
    z-index: 5;
}
</style>


// WEBPACK FOOTER //
// src/views/ex.vue